/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightObservedItinerary } from "./FlightObservedItinerary";
import {
  FlightObservedItineraryFromJSON,
  FlightObservedItineraryFromJSONTyped,
  FlightObservedItineraryToJSON,
  FlightObservedItineraryToJSONTyped,
} from "./FlightObservedItinerary";

/**
 *
 * @export
 * @interface FlightTestOffer
 */
export interface FlightTestOffer {
  /**
   *
   * @type {string}
   * @memberof FlightTestOffer
   */
  selectionToken: string;
  /**
   *
   * @type {string}
   * @memberof FlightTestOffer
   */
  provider: FlightTestOfferProviderEnum;
  /**
   *
   * @type {number}
   * @memberof FlightTestOffer
   */
  totalAmount: number;
  /**
   *
   * @type {string}
   * @memberof FlightTestOffer
   */
  currency: string;
  /**
   *
   * @type {Date}
   * @memberof FlightTestOffer
   */
  expiresAt: Date;
  /**
   *
   * @type {FlightObservedItinerary}
   * @memberof FlightTestOffer
   */
  itinerary: FlightObservedItinerary;
  /**
   *
   * @type {string}
   * @memberof FlightTestOffer
   */
  cabin?: string | null;
}

/**
 * @export
 */
export const FlightTestOfferProviderEnum = {
  Duffel: "duffel",
  Travelport: "travelport",
} as const;
export type FlightTestOfferProviderEnum =
  (typeof FlightTestOfferProviderEnum)[keyof typeof FlightTestOfferProviderEnum];

/**
 * Check if a given object implements the FlightTestOffer interface.
 */
export function instanceOfFlightTestOffer(
  value: object
): value is FlightTestOffer {
  if (!("selectionToken" in value) || value["selectionToken"] === undefined)
    return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("totalAmount" in value) || value["totalAmount"] === undefined)
    return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("expiresAt" in value) || value["expiresAt"] === undefined) return false;
  if (!("itinerary" in value) || value["itinerary"] === undefined) return false;
  return true;
}

export function FlightTestOfferFromJSON(json: any): FlightTestOffer {
  return FlightTestOfferFromJSONTyped(json, false);
}

export function FlightTestOfferFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightTestOffer {
  if (json == null) {
    return json;
  }
  return {
    selectionToken: json["selection_token"],
    provider: json["provider"],
    totalAmount: json["total_amount"],
    currency: json["currency"],
    expiresAt: new Date(json["expires_at"]),
    itinerary: FlightObservedItineraryFromJSON(json["itinerary"]),
    cabin: json["cabin"] == null ? undefined : json["cabin"],
  };
}

export function FlightTestOfferToJSON(json: any): FlightTestOffer {
  return FlightTestOfferToJSONTyped(json, false);
}

export function FlightTestOfferToJSONTyped(
  value?: FlightTestOffer | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    selection_token: value["selectionToken"],
    provider: value["provider"],
    total_amount: value["totalAmount"],
    currency: value["currency"],
    expires_at: value["expiresAt"].toISOString(),
    itinerary: FlightObservedItineraryToJSON(value["itinerary"]),
    cabin: value["cabin"],
  };
}
